// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconMoon = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C33.2169 8 34.4123 8.0913 35.58 8.26704C37.6871 8.58413 38.1707 10.9595 36.3029 11.9851C31.3548 14.7021 28 19.9553 28 26C28 34.8365 35.1635 42 44 42C46.3241 42 48.531 41.5031 50.5224 40.6106C52.479 39.7337 54.1606 41.4619 53.1453 43.3504C49.0971 50.8802 41.1482 56 32 56Z" />
    </svg>
  );
};
